import React from 'react';
import SiteHelpPage from '../components/siteContent/SiteHelpPage';

const HelpCenter = () => <SiteHelpPage />;

export default HelpCenter;
